module.exports = __webpack_public_path__ + "media/MRI2B.23035ddc.mp3";